import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'

import licensesEpics from './Licenses/epics'
import {
  delCompanyLogoError,
  delCompanyLogoSuccess,
  getAdeKillswitchError,
  getAdeKillswitchSuccess,
  getGeneralSettingsError,
  getGeneralSettingsSuccess,
  updateAdeKillswitchError,
  updateAdeKillswitchSuccess,
  updateGeneralSettingsError,
  updateGeneralSettingsSuccess,
} from './actions'
import {
  ADE_KILLSWITCH_REQUEST_ASYNC,
  ADE_KILLSWITCH_UPDATE,
  DEL_LOGO_REQUEST,
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
} from './constants'

const getGeneralSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DEL_LOGO_REQUEST.SUCCESS,
      GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE,
      UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.general)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getGeneralSettings(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getGeneralSettingsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getGeneralSettingsError, error)))
        .takeUntil(action$.ofType(GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL))
    )

const updateGeneralSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE).mergeMap((action) => {
    const payload = {
      ...store.getState().form.GeneralSettingsForm.values,
      ...action.payload,
    }
    return api.settings
      .updateGeneralSettings(store.getState().partnerOptions.selectedCompany?.value, payload)
      .map(() => updateGeneralSettingsSuccess(payload))
      .catch((error) => Observable.of(epicsErrorHandler(updateGeneralSettingsError, error)))
      .takeUntil(action$.ofType(UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL))
  })

const getAdeKillswitchEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(ADE_KILLSWITCH_REQUEST_ASYNC.INITIATE, ADE_KILLSWITCH_UPDATE.SUCCESS)
    .mergeMap(() =>
      api.ade
        .getAdeKillswitch(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getAdeKillswitchSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getAdeKillswitchError, error)))
        .takeUntil(action$.ofType(ADE_KILLSWITCH_REQUEST_ASYNC.CANCEL))
    )

const updateAdeKillswitchEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ADE_KILLSWITCH_UPDATE.INITIATE).mergeMap((action) =>
    api.ade
      .putAdeKillswitch(action.payload.data, store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => updateAdeKillswitchSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updateAdeKillswitchError, error)))
      .takeUntil(action$.ofType(ADE_KILLSWITCH_UPDATE.CANCEL))
  )

const delCompanyLogoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DEL_LOGO_REQUEST.INITIATE).mergeMap(() =>
    api.settings
      .delCompanyLogo()
      .map((response) => delCompanyLogoSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(delCompanyLogoError, error)))
      .takeUntil(action$.ofType(DEL_LOGO_REQUEST.CANCEL))
  )

export default combineEpics(
  getGeneralSettingsEpic,
  updateGeneralSettingsEpic,
  delCompanyLogoEpic,
  getAdeKillswitchEpic,
  updateAdeKillswitchEpic,
  licensesEpics
)
